<!-- Header con navegación -->
<div class="productos-header">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
            <button type="button" class="btn btn-outline-secondary btn-sm me-3" (click)="onVolver()">
                <i class="fas fa-arrow-left me-2"></i>Volver
            </button>
            
            <div class="d-flex align-items-center">
                <div class="operadora-logo-small" *ngIf="operadora">
                    <img [src]="operadora.urlImag || '/assets/brandLogos/default.svg'" 
                         [alt]="operadora.name" 
                         class="logo-small">
                </div>
                <div>
                    <h6 class="header-title mb-0">
                        <i class="fas fa-shopping-bag me-2"></i>Productos Disponibles
                    </h6>
                </div>
            </div>
        </div>
        
        <!-- Badges de navegación a la derecha -->
        <div class="d-flex align-items-center gap-2">
            <span *ngIf="operadora" class="badge bg-primary">{{ operadora.name }}</span>
            <span *ngIf="tipoOperacion" class="badge bg-info">{{ tipoOperacion.name }}</span>
            <span *ngIf="!tipoOperacion && tipoCode" class="badge bg-info">{{ tipoCode }}</span>
        </div>
    </div>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
    <div class="loading-content">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="loading-text">Cargando productos disponibles...</p>
    </div>
</div>

<!-- Error State -->
<div *ngIf="error && !isLoading" class="error-container">
    <div class="error-content">
        <i class="fas fa-exclamation-triangle error-icon"></i>
        <h5 class="error-title">Error al cargar productos</h5>
        <p class="error-message">{{ error }}</p>
        <button type="button" class="btn btn-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Reintentar
        </button>
    </div>
</div>

<!-- Empty State -->
<div *ngIf="!isLoading && !error && productos.length === 0" class="empty-container">
    <div class="empty-content">
        <i class="fas fa-shopping-bag empty-icon"></i>
        <h5 class="empty-title">No hay productos disponibles</h5>
        <p class="empty-message">
            No se encontraron productos activos para la combinación de
            <strong>{{ operadora?.name || operadoraCode }}</strong> → 
            <strong>{{ tipoOperacion?.name || tipoCode }}</strong>.
        </p>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Actualizar
        </button>
    </div>
</div>

<!-- Success State - Lista de Productos -->
<div *ngIf="!isLoading && !error && productos.length > 0" class="productos-container">
    
    <!-- Header del contenido -->
    <div class="productos-content-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h6 class="content-title">
                    <i class="fas fa-list me-2"></i>Productos Disponibles
                </h6>
                <p class="content-subtitle">
                    Información de productos y escalas de montos disponibles
                </p>
            </div>
            <div class="header-count">
                <span class="badge bg-success">{{ productos.length }} productos disponibles</span>
            </div>
        </div>
    </div>

    <!-- Grid de Productos -->
    <div class="productos-grid">
        <div *ngFor="let producto of productos; trackBy: trackByCode" 
             class="producto-card">
            
            <!-- Header del producto -->
            <div class="producto-header">
                <div class="producto-icon">
                    <i class="fas fa-credit-card"></i>
                </div>
                <div class="producto-info">
                    <h5 class="producto-name">{{ producto.name }}</h5>
                    <p class="producto-description">{{ producto.description }}</p>
                </div>
                <div class="producto-status">
                    <span class="status-badge status-active" *ngIf="producto.status">
                        <i class="fas fa-check-circle me-1"></i>Activo
                    </span>
                </div>
            </div>

            <!-- Escalas de montos disponibles con diseño innovador -->
            <div class="escalas-section-modern" *ngIf="producto.params?.sequence?.BS?.list">
                <div class="escalas-header-modern">
                    <div class="escalas-title">
                        <i class="fas fa-coins me-2"></i>
                        <span>Montos Disponibles</span>
                    </div>
                    <div class="escalas-actions">
                        <span class="escalas-count me-2">
                            {{ producto.params?.sequence?.BS?.list?.length || 0 }} opciones
                        </span>
                        <!-- Botón de editar oculto para usuarios normales -->
                        <!-- <button type="button" class="btn btn-outline-secondary btn-sm edit-sequence-btn" (click)="onEditSequence(producto)">
                            <i class="fas fa-cog me-1"></i>Editar
                        </button> -->
                    </div>
                </div>
                
                <div class="escalas-grid">
                    <div *ngFor="let monto of producto.params?.sequence?.BS?.list; trackBy: trackByMonto"
                         class="escala-chip"
                         [class.default-chip]="monto === producto.params?.sequence?.BS?.default">
                        <div class="chip-content">
                            <span class="monto-principal">{{ monto }}</span>
                            <span class="monto-currency">BS</span>
                        </div>
                        <div *ngIf="monto === producto.params?.sequence?.BS?.default" class="default-indicator">
                            <i class="fas fa-star"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Información adicional siempre al final -->
            <div class="producto-info-footer">
                <!-- Información del monto por defecto -->
                <div class="default-info" *ngIf="producto.params?.sequence?.BS?.default">
                    <small class="text-muted">
                        <i class="fas fa-star me-1"></i>
                        {{ producto.params?.sequence?.BS?.default }} BS es el monto recomendado
                    </small>
                </div>
                
                <!-- Información del rango oculta -->
                <!-- <div class="range-info-footer">
                    <small class="text-muted">
                        <i class="fas fa-info-circle me-1"></i>
                        Rango disponible: {{ producto.min }} - {{ producto.max }} BS
                    </small>
                </div> -->
            </div>
        </div>
    </div>

    <!-- Footer con información adicional -->
    <div class="productos-footer">
        <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
                <i class="fas fa-info-circle me-1"></i>
                Información de productos y escalas disponibles para operaciones
            </small>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onRetry()">
                <i class="fas fa-sync-alt me-2"></i>Actualizar
            </button>
        </div>
    </div>
</div>

<!-- Modal de Edición de Secuencia -->
<div class="modal fade" 
     [class.show]="isEditingSequence" 
     [style.display]="isEditingSequence ? 'block' : 'none'"
     tabindex="-1" 
     *ngIf="isEditingSequence">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      
      <!-- Header del Modal -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-cog me-2"></i>Editar Secuencia
        </h5>
        <button type="button" class="btn-close" (click)="onCloseSequenceModal()"></button>
      </div>

      <!-- Body del Modal -->
      <div class="modal-body">
        
        <!-- Información del Producto -->
        <div class="edit-product-header mb-4" *ngIf="editingProduct">
          <h6 class="product-name">{{ editingProduct.name }}</h6>
          <small class="text-muted">{{ editingProduct.description }}</small>
        </div>

        <!-- Error Message -->
        <div class="alert alert-danger alert-sm" *ngIf="sequenceError">
          <i class="fas fa-exclamation-triangle me-2"></i>{{ sequenceError }}
        </div>

        <!-- Input para agregar montos -->
        <div class="add-amount-section mb-4">
          <label class="form-label">Agregar nuevo monto</label>
          <div class="input-group">
            <input type="number" 
                   class="form-control" 
                   placeholder="Ingrese monto"
                   #newAmountInput
                   min="1"
                   step="1">
            <span class="input-group-text">BS</span>
            <button class="btn btn-primary" 
                    type="button" 
                    (click)="onAddNewAmount(newAmountInput.value); newAmountInput.value = ''">
              <i class="fas fa-plus me-2"></i>Agregar
            </button>
          </div>
        </div>

        <!-- Montos actuales con diseño de chips -->
        <div class="current-amounts-section" *ngIf="editingSequence?.BS?.list?.length">
          <label class="form-label">Montos disponibles ({{ editingSequence.BS.list.length }})</label>
          
          <div class="amounts-chips-grid">
            <div *ngFor="let amount of editingSequence.BS.list; trackBy: trackByMonto"
                 class="amount-chip-editable"
                 [class.default-chip-editable]="amount === editingSequence.BS.default">
              
              <div class="chip-content-editable">
                <span class="monto-principal-editable">{{ amount }}</span>
                <span class="monto-currency-editable">BS</span>
              </div>

              <!-- Selector por defecto mejorado -->
              <div class="default-toggle" 
                   (click)="onSetDefault(amount)"
                   [class.active]="amount === editingSequence.BS.default"
                   title="Establecer como por defecto">
                <div class="toggle-circle"></div>
                <span class="toggle-label">Por defecto</span>
              </div>

              <!-- Botón de eliminar -->
              <div class="chip-actions">
                <button type="button" 
                        class="btn-delete"
                        (click)="onRemoveAmount(amount)"
                        [disabled]="editingSequence.BS.list.length <= 1"
                        title="Eliminar monto">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Estado vacío -->
        <div class="empty-amounts" *ngIf="!editingSequence?.BS?.list?.length">
          <div class="empty-content">
            <i class="fas fa-coins empty-icon"></i>
            <p class="empty-text">No hay montos configurados</p>
            <small class="text-muted">Agregue al menos un monto para continuar</small>
          </div>
        </div>

        <!-- Información del monto por defecto -->
        <div class="default-info-modal mt-3" *ngIf="editingSequence?.BS?.default">
          <small class="text-warning">
            <i class="fas fa-info-circle me-1"></i>
            <strong>{{ editingSequence.BS.default }} BS</strong> es el monto por defecto
          </small>
        </div>
      </div>

      <!-- Footer del Modal -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="onCloseSequenceModal()" [disabled]="isSavingSequence">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSaveSequence()" [disabled]="isSavingSequence || !editingSequence?.BS?.list?.length">
          <span class="spinner-border spinner-border-sm me-2" *ngIf="isSavingSequence"></span>
          <i class="fas fa-save me-2" *ngIf="!isSavingSequence"></i>
          {{ isSavingSequence ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del Modal -->
<div class="modal-backdrop fade show" *ngIf="isEditingSequence" (click)="onCloseSequenceModal()"></div>
